/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Optionalfield1Inputs */

const en_optionalfield1 = /** @type {(inputs: Optionalfield1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`optional`)
};

const de_optionalfield1 = /** @type {(inputs: Optionalfield1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`optional`)
};

/**
* | output |
* | --- |
* | "optional" |
*
* @param {Optionalfield1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const optionalfield1 = /** @type {((inputs?: Optionalfield1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Optionalfield1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_optionalfield1(inputs)
	return de_optionalfield1(inputs)
});
export { optionalfield1 as "optionalField" }